import React from "react";
import StatusIndicator from "../shared/StatusIndicator";
import RaceWaitingIndicator from "../shared/RaceWaitingIndicator";
import AotdSignupCta from "../AotdSignupCta";

/**
 * Handles both `no_art` (authenticated, starting generation) and
 * `unauthorized` (logged out) branches the monolith collapsed into one
 * render block at lines 1565–1592. The orchestrator auto-retries on
 * `no_art` after 2 s when authenticated, so this view is short-lived.
 */
export interface NoArtOrUnauthorizedStateProps {
  isAuthenticated: boolean;
  participantCount?: number;
  participantEmojis?: string[];
  phase?: string;
}

export const NoArtOrUnauthorizedState: React.FC<NoArtOrUnauthorizedStateProps> = ({
  isAuthenticated,
  participantCount,
  participantEmojis,
  phase,
}) => (
  <div className="art-box" style={{ textAlign: "center", paddingTop: "30px" }}>
    {isAuthenticated ? (
      <h3 style={{ fontSize: "1.2rem", marginBottom: "15px" }}>Generating Art of the Day...</h3>
    ) : null}
    {isAuthenticated ? (
      <div
        className="spinner-container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100px",
        }}
      >
        <StatusIndicator status="started" overlay={false} phase={phase} />
        <RaceWaitingIndicator
          active
          participantCount={participantCount}
          participantEmojis={participantEmojis}
        />
        <p style={{ marginTop: "15px", fontSize: "0.9rem", color: "#555" }}>
          Starting generation process...
        </p>
      </div>
    ) : (
      <AotdSignupCta />
    )}
  </div>
);

export default NoArtOrUnauthorizedState;
